import { applyMiddleware, legacy_createStore, Store } from "redux"
import { composeWithDevTools } from "redux-devtools-extension"
import createSagaMiddleware, { SagaMiddleware } from "redux-saga"
import { Action } from "../modules/action/Action"
import { MainState } from "../modules/state/MainState"
import { reducer } from "./reducer"

export const sagaMiddleware: SagaMiddleware<object> = createSagaMiddleware()
export const store: Store<MainState, Action> = legacy_createStore(reducer, composeWithDevTools(applyMiddleware(sagaMiddleware)))
